// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/spectra/spectraviewer';
export const DRAWER_WIDTH = 180;
export const MINI_DRAWER_WIDTH = 60;

